// ** Initial State
const initialState = {
    result_list: [],
    result: null,
    total: 0,
    sign: null,
    timestamp: null,
    endpoint: null,
    notification: null,
    social_UUID: null
}

const chatEventList = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_EVENT_LIST':
            return {
                ...state,
                result_list: action.data,
                total: action.total,
                social_UUID: action.social_UUID || null
            }
        case 'CHAT_EVENT_LIST_CLEAR':
            return {
                ...state,
                result_list: [],
                total: 0,
                social_UUID: null
            }
        default:
            return { ...state }
    }
}

const chatSign = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_EVENT_SIGN':
            return {
                ...state,
                timestamp: action.data?.ws?.timestamp || null,
                endpoint: action.data?.ws?.url || null
            }
        default:
            return { ...state }
    }
}

const chatNotification = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_NOTIFICATION':
            return {
                ...state,
                notification: action.data || null
            }
        default:
            // Same reference for unrelated actions: ChatNotification toasts on
            // a change of this object, so a fresh copy here re-toasted the last
            // message on every dispatch anywhere in the app.
            return state
    }
}

const chatEscalation = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_ESCALATION':
            return {
                ...state,
                notification: action.data || null
            }
        default:
            // See chatNotification: a new object here re-toasted the escalation.
            return state
    }
}


export {
    chatEventList,
    chatSign,
    chatNotification,
    chatEscalation
}
